import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { regions } from "../../../../../../redux/route-management/regions/action";
import { selectRegionsListItems } from "../../../../../../redux/route-management/regions/selector";

const TransporterRegions = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectRegionsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'RegionName', headerName: 'Region Name', sortable: true, filter: true,isEdit: true },
          { field: 'ContactPerson', headerName: 'Contact Person' },
          { field: 'ContactNumber', headerName: 'Contact Number' },
          { field: 'CreatedOnUtc', headerName: 'Created On' },
      
        ]);
      }
      const fetchRegions=()=>{
        dispatch(regions.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/regions/list`,entity:'regions',jsonData:{
          
        "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",  
        // "Filters": [
          //     {
          //       "FieldName": "CustomerId",
          //       "FilterOperatorId": 1,
          //       "FieldValue": 316999,
          //       "FieldType": "number"
          //     }
          //   ],
      }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchRegions()
	}, [pageData])

	return (
   
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination} headingName="Regions" />
       
     
	);
};

export default TransporterRegions;


